import { render, staticRenderFns } from "./AttachmentsView.vue?vue&type=template&id=7b60f724&scoped=true&"
import script from "./AttachmentsView.vue?vue&type=script&lang=js&"
export * from "./AttachmentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60f724",
  null
  
)

export default component.exports